import childService from '@/services/ChildService';

const initialState = {
	child: {},
	children: [],
	childrenForSelect: [],
	teams: []
};

export default {
	namespaced: true,

	//#region [ State ]
	state: {
		...initialState
	},
	//#endregion

	//#region [ Mutations ]
	mutations: {
		setChild(state, payload) {
			state.child = payload.child;
			state.teams = payload.teams;
		},
		setChildren(state, payload) {
			state.children = payload;
		},
		setChildrenForSelect(state, payload) {
			state.childrenForSelect = payload;
		}
	},
	//#endregion

	//#region [ Actions ]
	actions: {
		async getChildren({ commit }) {
			try {
				let data = await childService.getAllChildren();
				commit('setChildren', data);
				return data;
			} catch (error) {
				console.log(error);
			}
		},
		async getChildById({ commit }, id) {
			try {
				let data = await childService.getChild(id);
				commit('setChild', data);
				return data;
			} catch (error) {
				console.log(error);
			}
		},
		async getChildrenForSelect({ commit }) {
			try {
				let data = await childService.getAllForSelect(null, 10000);
				commit('setChildrenForSelect', data);
				return data;
			} catch (error) {
				console.log(error);
			}
		},
		// eslint-disable-next-line no-unused-vars
		async updateChild({ commit }, { child, childTeamsSelected }) {
			let { id, name, lastName } = child;
			try {
				await childService.putChild(id, name, lastName, childTeamsSelected);
				//console.log(data.Message);
			} catch (error) {
				console.log(error);
			}
		},
		// eslint-disable-next-line no-unused-vars
		async saveChild({ commit }, child) {
			let { name, lastName, teams } = child;
			try {
				let response = await childService.postChild(name, lastName, teams);
				return response;
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async updateDataChild({ commit }, documentChildObj) {
			let { _id, params } = documentChildObj;
			try {
				await childService.putDataChild(_id, params);
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async updateDocumentChild({ commit }, documentChildObj) {
			let { _id, params } = documentChildObj;
			try {
				await childService.putDocumentChild(_id, params);
			} catch (error) {
				console.log(error);
			}
		}
	},
	//#endregion

	//#region [ Getters ]
	getters: {}
	//#endregion
};
